import clsx from 'clsx'
import {useState} from 'react'
import {NavLink} from 'react-router-dom'

import Icon from './Icon'
import {useAuth} from '~/hooks/useAuth'
import {logout} from '~/services/http/auth'
import {trl} from '~/services/intl'

export default function Navigation() {
    const {auth} = useAuth()

    const [opened, setOpened] = useState(false)

    const isRoot = auth?.profile?.user.type == 'root'
    const isAdmin = auth?.profile?.user.type == 'admin'

    return <div
        className={clsx(
            'navigation navigation_left flex flex_column flex_between',
            opened && 'navigation_opened'
        )}
    >
        <div className='flex flex_column flex_g-1'>
            <div className='navigation__logo flex flex_nowrap flex_center-items flex_g-4'>
                <Icon name='logo'/>
                <span>AI assistants</span>
            </div>
            <NavigationItem
                to='/models'
                title={trl('Модели')}
                icon='models'
            />
            <NavigationItem
                to='/assistants'
                title={trl('Ассистенты')}
                icon='assistants'
            />
            <NavigationItem
                to='/chats'
                title={trl('Чаты')}
                icon='chats'
            />
            <NavigationItem
                to='/sources'
                title={trl('Источники')}
                icon='sources'
            />
            {(isRoot || isAdmin) &&
                <NavigationItem
                    to='/administration'
                    title={trl('Администрирование')}
                    icon='administration'
                />
            }
        </div>
        <div className='flex flex_column flex_g-1'>
            <NavigationItem
                to='/profile'
                title={trl('Профиль')}
                icon='profile'
            />
            <button
                className='navigation__item flex flex_nowrap flex_center-items flex_g-4'
                type='button'
                onClick={() => logout()}
            >
                <Icon name='logout'/>
                <span>{trl('Выйти')}</span>
            </button>
            <hr className='hr hr_navigation'/>
            <button
                className='navigation__item flex flex_nowrap flex_center-items flex_g-4'
                type='button'
                onClick={() => setOpened(!opened)}
            >
                <Icon name={opened ? 'arrows-left' : 'arrows-right'}/>
                <span>{trl('Свернуть панель')}</span>
            </button>
        </div>
    </div>
}

function NavigationItem({to, title, icon}: {to: string, title: string, icon: string}) {
    const getClassName = ({isActive}: {isActive: boolean}) => clsx(
        'navigation__item flex flex_nowrap flex_center-items flex_g-4',
        isActive && 'navigation__item_active',
    )

    return <NavLink
        to={to}
        title={title}
        className={getClassName}
    >
        <Icon name={icon}/>
        <span>{title}</span>
    </NavLink>
}
